import React from 'react';

import { NavLink } from 'react-router-dom'

const ItemLink = React.forwardRef( ( props , ref ) => <NavLink innerRef={ref} {...props} /> ) ;

export default ItemLink;
